import { MruCache } from 'owa-mru-cache';
import ConversationItemParts from './schema/ConversationItemParts';

const cacheSize = 50;
const conversationCache = new MruCache<ConversationItemParts>(cacheSize);
export default conversationCache;
